import { formatDate } from '@btime/helpers'

import { isInterpolation } from '../../../../../../../../../utils/helpers/interpolation'
import { INTERPOLATIONS } from './constants'

export const formatDynamicValue = (type, value) => {
  switch (type) {
    case 'date':
    case 'datetime':
      if (isInterpolation(value)) {
        return INTERPOLATIONS.find(interpolation => interpolation.id === value)?.name
      }
      const formattedDate = formatDate('DD/MM/YYYY', value)
      const formattedTime = formatDate('HH:mm', value)
      return `${formattedDate}${type === 'datetime' ? ` ${formattedTime}` : ''}`
    default:
      return value
  }
}
